import { SearchPersonVM } from 'mutation/view-models/civil-union';
import { SearchPerson } from 'shell/view-models/search-anpr';

export const transformerSearchPerson = (values: SearchPersonVM): SearchPerson => {
  const response: SearchPerson = {
    datiRichiesta: {
      ricercaNazionale: '1', // fixed
    },
    criteriRicerca: {
      codiceFiscale: values?.fiscalCode || undefined,
      cognome: values?.surname || undefined,
      nome: values?.name || undefined,
      senzaCognome: !values?.surname || values?.withoutSurname ? '1' : '0',
      senzaNome: !values?.name || values?.withoutName ? '1' : '0',
      sesso: values?.gender || undefined,
    },
  };

  return response;
};
